import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useParams } from "react-router-dom";

const NewNetworkModal = ({ show, handleClose, fetchRecords }) => {
    const { t } = useLanguage();
    const user_id = sessionStorage.getItem("user_id");
    const { project_id } = useParams()
    const [ipName, setIPName] = useState(null)
    const [ip, setIp] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({ message: "", display: false })

    const SetCurrentIP = () => {
        fetch('https://api64.ipify.org?format=json')
            .then((response) => response.json())
            .then((data) => {
                setIp(data.ip)
            })
            .catch((error) => {
                setError({ message: "Error during IP fetch", display: true })
            });
    }


    const SaveIpAdress = async () => {
        setLoading(true)
        setError({ message: "", display: false })

        if (ipName != null || ip != null) {

            let dataToSend = {
                user_id: user_id,
                name: ipName,
                ip: ip,
                project_id: project_id
            }
            try {
                const response = await fetch('https://backend.erioon.com/save_ip_adress', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend),
                });
                setLoading(false)
                const result = await response.json();
                if (response.ok) {
                    CloseModal()
                    fetchRecords()
                } else {
                    if (result.error == "Duplicate_ip_found") {
                        setError({ message: "This IP adress is already present", display: true })
                    } else {
                        setError({ message: t.err_save_general, display: true })
                    }
                }
            } catch (error) {
                setLoading(false)
                setError({ message: t.err_save_general, display: true })
            }
        }

    }

    const accessFromAnywhere = () => {
        setIp("0.0.0.0/0")
    }

    const CloseModal = () => {
        setIPName(null)
        handleClose()
        setError({ message: "", display: false })
    }

    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label">Add a new IP adress</p>
                <div className="warning_delete_message">
                    <p>Erioon only allows connections to this project resources from entries in the project’s IP Access List.<br /> Each entry should either be a single IP address or a CIDR-notated range of addresses.</p>
                </div>
                {ip == "0.0.0.0/0" && (
                    <div className="warning_delete_message">
                        <p><strong><i className="fa-solid fa-warning"></i> This resource is configured to allow connections from any IP address ({ip}), which means it is accessible to anyone on the internet.</strong></p>
                    </div>
                )}
                <input
                    className="api_name_input"
                    placeholder="IP name tag"
                    value={ipName}
                    onChange={(e) => setIPName(e.target.value)}
                ></input>
                <input
                    className="api_name_input"
                    placeholder="IP or Range of IPs"
                    value={ip}
                    onChange={(e) => setIp(e.target.value)}
                ></input>
                <div className="ip_btn_cont">
                    <button className="save_btn add_current_ip_btn" onClick={SetCurrentIP}>Add current IP</button>
                    <button className="save_btn add_current_ip_btn" onClick={accessFromAnywhere}>Access from anywhere</button>

                </div>
            </div>
            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button
                        className="save_btn"
                        onClick={SaveIpAdress}
                        disabled={ipName === null || ipName.trim() === "" || ipName == null || ip == null}
                    >
                        {loading ? (
                            <Spinner loading={loading} />
                        ) : (
                            <>
                                {t.save} IP
                            </>
                        )}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>
                        {t.cancel}
                    </button>
                </div>

            </div>
        </Modal>
    );
};

export default NewNetworkModal;
